import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { AiOutlineControl } from "react-icons/ai";
import { LuWorkflow } from "react-icons/lu";
import { CiServer } from "react-icons/ci";
import { LuServer } from "react-icons/lu";
import { PiShieldCheck } from "react-icons/pi";
import { IoCheckmarkCircle } from "react-icons/io5";
import { IoAlertCircle } from 'react-icons/io5';
import { LuArrowRight } from "react-icons/lu";
import UnitsIcons from "./UnitsIcons";
import { GoAlert } from "react-icons/go";
import { CiViewTimeline } from "react-icons/ci";
import { setSidebarCollapsed } from "../store/actions/authActions";
import { CiCircleAlert } from "react-icons/ci";
import { HiOutlineChartBar } from "react-icons/hi2";
import { BsFiles } from "react-icons/bs";
import { IoDocumentTextOutline } from "react-icons/io5";
import { LuPanelLeft, LuPanelRight } from "react-icons/lu"
import { useTranslation } from "react-i18next";


const UnitsTopBar = (props) => {
    const { t } = useTranslation();
    const {
        menuitem,
        setMenuItem,
        activeDepartmentId,
        departments,
        setSidebarCollapsedFN,
        sidebar_collapsed,
        openReport,
    } = props;
    ////console.log("menuitem ", menuitem)
    const getSvgProps = (path) => {
        ////////console.log(path)
        return menuitem === path
            ? { fill: "#3b3b3b", what: path }
            : { fill: "#c3cfd1", what: path };
    };

    const activeDepartment =
        departments?.find((department) => department.department_id === activeDepartmentId) || {};
    ////console.log(activeDepartment)
    const activeDepartmentName = activeDepartment?.name || "N/A";
    const activeDepartmentColor = activeDepartment?.color || "";
    const company_name = activeDepartment?.company_name || "";
    return (
        <div
            className={`flex w-full h-16 bg-[#F4F4F4] transition-width duration-300 border-b border-gray-300`}
        >
            {sidebar_collapsed && (
                <div>
                    <button
                        className="p-5 pl-0 ml-5"
                        onClick={() => setSidebarCollapsedFN(!sidebar_collapsed)}
                        title="Toggle sidebar"
                    >
                        <div className="relative flex items-center justify-center w-8 h-8 hover:bg-white hover:rounded-full mt-[-2px] transition">
                            <LuPanelLeft className="w-5 h-5 text-[#3b3b3b] hover:text-black" />
                        </div>
                    </button>
                </div>
            )}

            <nav className="flex flex-row justify-start w-full overflow-x-auto whitespace-nowrap scrollbar-hide">
                <div className="flex items-center p-2 mx-4 text-[#464646] text-mm">
                    <div
                        title={activeDepartmentName}
                        className="flex items-center justify-center w-8 h-8 m-2 rounded-xl hover:bg-[#3b3b3b] hover:bg-opacity-20 ml-0"
                        style={{ backgroundColor: activeDepartmentColor }}
                    >
                        <span className="text-white font-bold text-[12px]">
                            {activeDepartmentName !== "N/A"
                                ? activeDepartmentName
                                    .split(" ")
                                    .filter((word) => word.toLowerCase() !== "and")
                                    .map((word) => word.charAt(0).toUpperCase())
                                    .slice(0, 2)
                                    .join("")
                                : "NA"}
                        </span>
                    </div>

                    {/* Text block */}
                    <div className="flex flex-col ml-2 leading-tight">
                        {/* Department name */}
                        <span className="text-black font-medium">
                            {activeDepartmentName}
                        </span>

                        {/* Company name (only if exists) */}
                        {company_name && (
                            <span className="text-[11px] text-gray-500">
                                {company_name}
                            </span>
                        )}
                    </div>
                </div>


                {[
                    { id: "dashboards", labelKey: "riskCenter.tabs.dashboard", icon: HiOutlineChartBar},
                    { id: "risk", labelKey: "riskCenter.tabs.risk" , icon: GoAlert},
                    { id: "controls", labelKey: "riskCenter.tabs.controls", icon: PiShieldCheck },
                    { id: "actions", labelKey: "riskCenter.tabs.actions", icon: CiViewTimeline },
                    { id: "incidents", labelKey: "riskCenter.tabs.incidents", icon: CiCircleAlert },
                    { id: "workflows", labelKey: "riskCenter.tabs.workflows", icon: LuWorkflow },
                    { id: "inventory", labelKey: "riskCenter.tabs.assets", icon: CiServer },
                    { id: "files", labelKey: "riskCenter.tabs.files", icon: BsFiles },
                    
                    {
                        id: "create_report",
                        labelKey: "riskCenter.tabs.reports",
                        icon: IoDocumentTextOutline
                        //action: openReport,
                    },
                ].map(({ id, labelKey, icon: Icon, action }) => (
                    <button
                        key={id}
                        onClick={() => {
                            if (action) {
                                action();
                            } else {
                                //////console.log("Menu", id)
                                setMenuItem(id);
                            }
                        }}
                        className={`flex items-center p-2 mx-4 text[#464646] hover:bg-white text-mm ${
                            menuitem === id
                                ? "border-b-2 border-[#3b3b3b] text-[#3b3b3b]"
                                : "text-gray-500"
                        }`}
                    >
                        {Icon ? (
                            <Icon 
                                className={`w-6 h-6`}
                                style={{ color: menuitem === id ? "#3b3b3b" : "#c3cfd1" }}
                            />
                        ) : (
                            <UnitsIcons {...getSvgProps(id)} className={`w-6 h-6`} />
                        )}
                        <span className={`ml-2`}>{t(labelKey)}</span>
                    </button>
                ))}
            </nav>
        </div>
    );
};

const mapStateToProps = (state) => {
    ////console.log("sidebar_collapsed ", state.auth.sidebar_collapsed)
    return {
        profile: state.profile.profile,
        sidebar_collapsed: state.auth.sidebar_collapsed,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSidebarCollapsedFN: (collapsed) => dispatch(setSidebarCollapsed(collapsed)),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(UnitsTopBar);